import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import Skeleton from '@mui/material/Skeleton';
import { makeStyles } from 'tss-react/mui';
import Card from '@mui/material/Card';

import { fetchNewsItem, clearNews } from '../store/actions/index';

import NewsFeed from '../components/NewsFeed';
import Image from '../components/Image';

import { titles } from '../utils/seoData';

const useStyles = makeStyles()(() => ({
  title: {
    marginBottom: `1rem`,
  },
  card: {
    backgroundColor: `rgba(0, 0, 0, 0)`,
    boxShadow: `none`,
  },
}));

const News = (props) => {
  const item = useSelector(state => state.news.item);
  const dispatch = useDispatch();

  useEffect(() => {
    const title = !item || !item.title ? '' : item.title;

    document.title = titles('news', title).title;
  });

  useEffect(() => {
    const { slug } = props.match.params;
    dispatch(fetchNewsItem(slug));

    return () => {
      dispatch(clearNews());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params]);

  const {classes} = useStyles();

  const renderTags = () => {
    if (!item.tags) {
      return null;
    }

    return map(item.tags, (tag, i) => {
      return (
        <dd key={i}>
          <Link to={`/${tag.description}/${tag.slug}`}>{tag.name}</Link>
        </dd>
      );
    });
  }

  const renderImage = () => {
    if (!item.media || !item.title) {
      return (
        <Card className={classes.card}>
          <Skeleton variant="rect" width={400} height={400}/>
        </Card>
      );
    }

    const imgSmall = item.media.sizes.medium.source_url;
    const imgLarge = item.media.sizes.full.source_url;

    return (
      <>
        <meta itemProp="image" content={imgLarge} />
        <Image
          imgSmall={imgSmall}
          imgLarge={imgLarge}
          name={item.title}
          imgClassName=""
        />
      </>
    );
  }

  const renderDate = (dateGMT) => {
    const date = new Date(dateGMT).toLocaleDateString(`en-us`);

    return date;
  }

  const renderContent = () => {
    if (!item.title) {
      return (
        <>
          <Skeleton width={`100%`} height={72} className={classes.title}/>
          <Skeleton variant="rect" width={`100%`} height={400} />
        </>
      );
    }

    return (
      <>
        <h1
          className="news--heading__title"
          dangerouslySetInnerHTML={{__html: item.title}}
        />

        <dl className="hashtag">
          {renderTags()}
        </dl>
        <p itemProp="datePublished" content={item.dateGMT}>{renderDate(item.dateGMT)}</p>
        <div dangerouslySetInnerHTML={{__html: item.content}} />
      </>
    );
  }

  return (
    <div className="page--container">
      <div className="page--content__group" itemScope itemType="https://schema.org/NewsArticle">
        <div className="page--content__one-third">
          {renderImage()}
        </div>
        <div className="page--content__two-third">
          {renderContent()}
        </div>
      </div>
      <NewsFeed />
    </div>
  );
}

News.propTypes = {
  fetchNewsItem: PropTypes.func,
  clearNews: PropTypes.func,
  params: PropTypes.object,
  item: PropTypes.object,
  match: PropTypes.object,
};

export default News;
